/* miscKeys.js -- THE ONE SPELLING OF A MISC REVENUE LINE'S INCOME-STATEMENT KEY (W-089, 2026-10-01).
 *
 * WHY THIS EXISTS: "an unrouted misc line lands on rev_misc_<id>" was spelled FOUR times -- runFullModel (the
 * deposit), computeIS (a second summer for Total Revenue), IncomeStatementPage (a row spliced at render time) and
 * ScenariosPage (its own key lookup). The statement BUILDER did not know the line at all, so every reader of the
 * skeleton missed it; measured in diffs/group3-phase0.txt, pre-flight P16 refused a correct model 9 times.
 * The builder now emits the leaf, and every site asks this file.
 *
 * THE TWO STATES -- misc is TWO-STATE, unlike implementation (utils/implKeys.js), which is three-state:
 *   target_gl_line_key set       ROUTED   -> the money lands on that existing IS leaf; no row of its own
 *   target_gl_line_key NULL/''   UNROUTED -> the line emits its own synthetic rev_misc_<id>
 * NULL is a WORKING ANSWER ("Create new IS line"), not an unanswered state: the builder owns that leaf. A misc
 * line has no sentinel. Do not mirror the implementation three-state test onto misc, or this one onto it.
 *
 * WHAT THIS CANNOT REACH: server/server.js cannot import client code (THE WALL). Since 2026-10-27 it spells rev_misc_ ONCE, in its
 * miscSyntheticKey (the "% of revenue" base rule, pctRevenueBaseKeysFromRows -- a misc line's own leaf is a vendor base); the two rules
 * are checked against each other by verify-wall-mirrors pair M25. (Previously read: "...(THE WALL); it never spells rev_misc_.")
 */

/** The synthetic IS-line key an unrouted misc line emits. */
export function miscSyntheticKey(id) {
  return `rev_misc_${id}`;
}

/** The IS-line key this misc line's forecast is deposited at: its target, or its own synthetic. */
export function miscLeafKey(line) {
  return (line && line.target_gl_line_key) || miscSyntheticKey(line && line.id);
}

/** True when this misc line emits its own row: enabled and not routed to an existing line. */
export function isUnroutedMisc(line) {
  return !!line && !!line.enabled && !line.target_gl_line_key;
}
